import Admin from '@/models/bread/Admin/syllabus'

export default {
  key:'Syllabus',
  name:{
    singular:'Syllabus',
    plural:'Syllabuses',
  },
  parents:[
    //
  ],
  Admin:Admin,
  Moderator:false,
  Teacher:false,
}